import { api, ensureCsrf, setCsrf } from './client';

export interface Me {
  user: { id: string; email: string; display_name: string; avatar_color?: string; username?: string | null; photo_url?: string | null };
  brand: { id: string; slug: string; display_name: string };
  csrf_token: string;
  workspaces: Array<{ id: string; name: string; role: string; owner_name?: string | null }>;
}

export async function me(): Promise<Me> {
  const r = await api<Me>('GET', '/auth/me');
  setCsrf(r.csrf_token);
  return r;
}
export async function login(email: string, password: string): Promise<Me> {
  setCsrf(null); await ensureCsrf();
  await api('POST', '/auth/login', { email, password });
  setCsrf(null);
  return me();
}
export async function register(email: string, password: string, displayName: string): Promise<Me> {
  setCsrf(null); await ensureCsrf();
  await api('POST', '/auth/register', { email, password, display_name: displayName });
  setCsrf(null);
  return me();
}
export async function logout(): Promise<void> { await api('POST', '/auth/logout'); setCsrf(null); }

/** Completes a password reset from the emailed link (`/app/?reset=TOKEN`); all sessions are revoked server-side. */
export async function completePasswordReset(token: string, password: string): Promise<void> {
  setCsrf(null); await ensureCsrf();
  await api('POST', '/auth/password-reset/complete', { token, password });
  setCsrf(null);
}
